import { render, staticRenderFns } from "./Purchaserecord.vue?vue&type=template&id=549f2fb7&scoped=true"
import script from "./Purchaserecord.vue?vue&type=script&lang=js"
export * from "./Purchaserecord.vue?vue&type=script&lang=js"
import style0 from "./Purchaserecord.vue?vue&type=style&index=0&id=549f2fb7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549f2fb7",
  null
  
)

export default component.exports